module.exports = __webpack_public_path__ + "static/img/areaA_8.2177644.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA_8.png
// module id = 981
// module chunks = 1